import { useInfiniteQuery } from '@tanstack/react-query';
import { getNextCursor } from '@/api/cursorPagination';
import { fetchDeviceAssignmentHistory } from '../api/deviceAssignmentHistory';

export const deviceAssignmentHistoryKeys = {
  all: ['deviceAssignmentHistory'] as const,
  list: (deviceId: string, companyId: string) =>
    [...deviceAssignmentHistoryKeys.all, deviceId, companyId] as const,
};

// useDeviceAssignmentHistory pages through the assignment history of a device as seen by
// the given company. Disabled until both ids are known.
export function useDeviceAssignmentHistory(deviceId: string, companyId: string | null) {
  return useInfiniteQuery({
    queryKey: deviceAssignmentHistoryKeys.list(deviceId, companyId ?? ''),
    queryFn: ({ pageParam }) => fetchDeviceAssignmentHistory(deviceId, companyId ?? '', { cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: getNextCursor,
    enabled: Boolean(deviceId && companyId),
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
